export enum SubscriptionType {
  Voice = 'Voice',
  MBB = 'MBB',
}
